import React, { Component } from "react";
import PrintPreview from "../PrintPreview";
import PdfStore from "stores/PdfStore";
import WorkdocStore from "stores/WorkdocStore";
import { Checkbox } from 'react-icheck';
const Barcode = require("react-barcode");
var NotificationSystem = require("react-notification-system");
class PrintSSTFixingListOnCarDoc extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      loading: false,
      data: {
        work_no: "",
        car: { car_registration_no: "" },
        insurer: { claim_no: "" },
        receiving: { entrance_date: "", appointment_date: "" },
        wagelist: [],
        partlist: [],
        department:[]
      },
    };

    var cssPagedMedia = (function () {
      var style = document.createElement("style");
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    })();

    cssPagedMedia.size = function (size) {
      cssPagedMedia("@page {size: " + size + "}");
    };
    cssPagedMedia.size("portrait");
  }

  componentDidMount() {
    this.loadFixingListOnCarDoc();
  }

  loadFixingListOnCarDoc() {
    let { workNo } = this.props;

    this.setState({ loading: true });
    PdfStore.loadFixingListOnCarDoc(workNo, "fixoncar_doc", (result) => {
      let data = result.data;
      this.setState({ data: data });
    });
  }

  onPrintDoc() {
    let { workNo } = this.props;
    WorkdocStore.updateCreateJobStatus(
      workNo,
      1,
      (result) => {
        this.refs.notificationSystem.addNotification({
          title: "แจ้งเตือน",
          message: "อับเดทออกใบจ็อบใหช่างเรียบร้อย " + workNo + " ",
          level: "info",
          position: "tc",
        });
      },
      (error) => {}
    );
  }

  // renderLogoUrl(logoUrl){
  //   let imgUrl = ''
  //   if (process.env.NODE_ENV == "development") {
  //     imgUrl = 'https://kkc.bigfix.co/korat/pdf/'+logoUrl
  //   }else{
  //     imgUrl = '../'+logoUrl
  //   }
  //   return (<img src={imgUrl} />)
  // }

  renderInsurerName(insurer) {
    let name = insurer.insurer_id * 1 !== 0 ? insurer.insurer_name : "เงินสด";
    name = (name + "").replace("บริษัท", "");
    name = name.replace("จำกัด", "");
    name = name.replace("(มหาชน)", "");
    name = name.replace("มหาชน", "");
    return <span>{name}</span>;
  }

  renderListData(list) {
    let first = list.slice(0, 5);
    let second = list.slice(5, 10);

    return new Array(5).fill("").map((item, index) => (
      <tr key={index}>
        <td style={{ width: "5%" }}>{index + 1}</td>
        <td
          style={{ width: "45%" }}
          className="hr2-b color-work-cover-file-doc"
        >
          {index < first.length ? first[index].detail : ""}
        </td>
        <td style={{ width: "5%" }} className="text-center">
          {index + 6}
        </td>
        <td
          style={{ width: "45%" }}
          className="hr2-b color-work-cover-file-doc"
        >
          {index < second.length ? second[index].detail : ""}
        </td>
      </tr>
    ));
  }

  renderComponentPage() {
    let { work_no, insurer, car, receiving, wagelist, partlist } =
      this.state.data;

    if (wagelist.length > 10 || partlist.length > 0) {
      let noOfPageWage = Math.floor(wagelist.length / 10) + 1;
      let noOfPagePart = Math.floor(partlist.length / 10) + 1;
      let noOfPage = noOfPagePart > noOfPageWage ? noOfPagePart : noOfPageWage;

      let pagelist = [];
      for (let i = 0; i < noOfPage; i++) {
        let begin = wagelist.length > 0 ? wagelist.slice(0, 10) : [];
        let beginPart = partlist.length > 0 ? partlist.slice(0, 10) : [];
        if (wagelist.length > 10) {
          wagelist = wagelist.slice(10);
        } else {
          wagelist = wagelist.slice(begin.length);
        }
        if (partlist.length > 10) {
          partlist = partlist.slice(10);
        } else {
          partlist = partlist.slice(beginPart.length);
        }
        pagelist.push({ wagelist: begin, partlist: beginPart });
      }
      //console.log('page',pagelist)
      return pagelist.map((item, index) =>
        this.renderComponentSinglePage(
          item.wagelist,
          item.partlist,
          index,
          noOfPageWage,
          noOfPagePart
        )
      );
      //return this.renderComponentSinglePage(wagelist,partlist)
    } else {
      return this.renderComponentSinglePage(wagelist, partlist);
    }
  }

  renderComponentSinglePage(
    wagelist,
    partlist,
    index = 0,
    noOfPageWage = 1,
    noOfPagePart = 1
  ) {
    let { work_no, insurer, car, receiving,department } = this.state.data;
    //const department = ['ช่างถอด','ช่างเคาะ','ช่างโปัวสี','ช่างพ่นสี','ช่างประกอบ','ช่างขัดสี']
    return (
      <div className="font-print" key={index}>
        <header>
          <h2 className="text-right">{"ใบรายการซ่อมติดหน้ารถ"}</h2>
        </header>
        <div className="font-30">
          <table className="table table-fixinglist-oncar">
            <tbody>
              <tr>
                <td style={{ width: "80px" }}>บริษัท</td>
                <td className="hr2-b text-center color-work-cover-file-doc">
                  {this.renderInsurerName(insurer)}
                </td>
                <td style={{ width: "50px" }}>รหัส</td>
                <td className="hr2-b text-center color-work-cover-file-doc font-lg">
                  {work_no}
                </td>
              </tr>
              <tr>
                <td style={{ width: "80px" }}>ทะเบียน</td>
                <td className="hr2-b text-center color-work-cover-file-doc">
                  {car.car_registration_no}
                </td>
                <td style={{ width: "120px" }}>รุ่นรถ</td>
                <td className="hr2-b text-center color-work-cover-file-doc">
                  {car.brand + "/" + car.model}
                </td>
              </tr>
              <tr>
                <td style={{ width: "80px" }}>สีรถ</td>
                <td className="hr2-b text-center color-work-cover-file-doc">
                  {car.car_color}
                </td>
                <td style={{ width: "120px" }}>ชื่อผู้ออกจ๊อบ</td>
                <td className="hr2-b text-center color-work-cover-file-doc">
                  {receiving.checking_by}
                </td>
              </tr>
            </tbody>
          </table>
          <table className="table table-fixinglist-oncar">
            <tbody>
              <tr>
                <td className="text-center">
                  <u>รายการซ่อม</u>
                  <span>
                    <u className="color-work-cover-file-doc">
                      *กรุณาถ่ายรูปให้ครบทุกขั้นตอนด้วยคะ*
                    </u>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          <table
            className="table table-fixinglist-oncar"
            style={{ marginTop: "0" }}
          >
            <tbody>{this.renderListData(wagelist)}</tbody>
          </table>
          <table className="table table-fixinglist-oncar">
            <tbody>
              <tr>
                <td className="text-center">
                  <u>รายการอะไหล่</u>
                </td>
              </tr>
            </tbody>
          </table>
          <table
            className="table table-fixinglist-oncar"
            style={{ marginTop: "0" }}
          >
            <tbody>{this.renderListData(partlist)}</tbody>
          </table>
          <table className="table table-fixinglist-oncar">
            <tbody>
              <tr>
                <td style={{ width: "15%" }}>วันรถเข้า</td>
                <td
                  style={{ width: "35%" }}
                  className="hr2-b color-work-cover-file-doc"
                >
                  {this.getDate(receiving.entrance_date)}
                </td>
                <td style={{ width: "15%" }} className="text-center">
                  นัดออก
                </td>
                <td
                  style={{ width: "35%" }}
                  className="hr2-b color-work-cover-file-doc"
                >
                  {this.getDate(receiving.appointment_date)}
                </td>
              </tr>
            </tbody>
          </table>
          <div className="text-center">
            <Barcode
              value={work_no}
              width={1}
              height={30}
              textAlign={"center"}
              fontSize={12}
            />
          </div>
        </div>
        {department && department.length > 0 && (
        <div>
          <table className="table table-fixinglist-oncar-footer">
            <tbody>
              <tr>
                <td style={{ width: "50px" }} className="text-center">ขั้นตอนการซ่อม</td>
                {department.map((name,index)=>(
                    <td
                    style={{ width: "35px" }}
                    className="text-center"
                  >
                    {name}
                  </td>
                ))}
                <td style={{ width: "50px" }} className="text-center">
                  ชื่อผู้ตรวจสอบ
                </td>
                <td
                  style={{ width: "50px" }}
                  className=""
                >
                </td>
              </tr>
              <tr>
                <td className="text-center">ชื่อช่าง</td>  
                {
                  department.map((name,index)=>(
                    <td >{' '}</td>
                  ))
                }              
                <td className="text-center">วันที่</td>
                <td >{' '}</td>
              </tr>
              <tr>
                <td className="text-center">วันที่/เวลา</td>
                {
                  department.map((name,index)=>(
                    <td >{' '}</td>
                  ))
                }    
                <td className="text-center">ผลการตรวจ</td>
                <td >
                <Checkbox
                   
                    checkboxClass={'icheckbox_square-blue '}
                    increaseArea="20%"
                    label=" ผ่าน"
                  /><br/>
                  <Checkbox
                   
                   checkboxClass={'icheckbox_square-blue '}
                   increaseArea="20%"
                   label=" ไม่ผ่าน"
                 />
                </td>
              </tr>
            </tbody>
          </table>          
        </div>)}
        <NotificationSystem ref="notificationSystem" />
      </div>
    );
  }

  getDate(date = "") {
    if (date != "" && date !== undefined) {
      let day = date.substring(0, 2);
      let month = date.substring(3, 5);
      let year = parseInt(date.substring(6, 10)) - 543;
      let _date = year + "-" + month + "-" + day;
      let d = new Date(_date);
      let weekday = new Array(7);
      weekday[0] = "วันอาทิตย์ ที่ ";
      weekday[1] = "วันจันทร์ ที่ ";
      weekday[2] = "วันอังคาร ที่ ";
      weekday[3] = "วันพุธ ที่ ";
      weekday[4] = "วันพฤหัสบดี ที่ ";
      weekday[5] = "วันศุกร์ ที่ ";
      weekday[6] = "วันเสาร์ ที่ ";
      let n = weekday[d.getDay()];
      return n + date;
    }
    return "";
  }

  render() {
    let { loading } = this.state;
    return (
      <PrintPreview
        loading={loading}
        leftBarTitle={"ใบซ่อมติดหน้ารถ " + this.props.workNo}
        onPrintDoc={this.onPrintDoc.bind(this)}
      >
        {this.renderComponentPage()}
      </PrintPreview>
    );
  }
}

PrintSSTFixingListOnCarDoc.defaultProps = {
  title: "ใบ",
  mode: "1",
};
export default PrintSSTFixingListOnCarDoc;



// WEBPACK FOOTER //
// ./src/view/print/sst/PrintSSTFixingListOnCarDoc.js